import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { Link as RRLink } from "react-router";
import { useTranslation } from "react-i18next";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { PageHeader } from "./PageHeader";

export const RegistrationNotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader sx={{ mb: 8 }}>{t("common.title")}</PageHeader>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 8 }}>
        <Paper
          sx={{
            p: { xs: 3, md: 5 },
            maxWidth: 560,
            width: "100%",
            textAlign: "center",
          }}
        >
          <Stack sx={{ alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                color: "text.secondary",
                display: "grid",
                placeItems: "center",
              }}
            >
              <SearchOffIcon sx={{ fontSize: 64 }} />
            </Box>
            <Typography variant="h4" component="h2">
              {t("registrationNotFound.title")}
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              {t("registrationNotFound.body")}
            </Typography>
            <Button
              variant="contained"
              component={RRLink}
              to="/"
              sx={{ mt: 2 }}
            >
              {t("common.goToHome")}
            </Button>
          </Stack>
        </Paper>
      </Box>
    </>
  );
};
